export function CreancesPageIntro({ filteredCount }: { filteredCount: number }) {
  return (
    <div className="mb-6 flex flex-col gap-2 lg:flex-row lg:items-end lg:justify-between">
      <p className="max-w-2xl text-sm text-muted-foreground">
        Échéances avec solde dû, pénalités associées et suivi des retards par client.
      </p>
      <p className="text-[11px] text-subtle">
        {filteredCount} résultat{filteredCount !== 1 ? "s" : ""} affiché
        {filteredCount !== 1 ? "s" : ""}
      </p>
    </div>
  );
}
